import { bindActionCreators } from '@reduxjs/toolkit';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { trackSoftConversionEvent } from '../../actions/tracking';
import { settings, urls } from '../../helpers';
import type { RootState } from '../../reducers';
import { getItem } from '../../selectors/item';
import { getRetailerLocaiton, getRetailerName } from '../../selectors/retailer';
import { softConversionEvents } from '../../shared/tracking';

const getLocalFile = (file: string): string => {
  if (!process.env.SSR) {
    return `${location.protocol}//${location.hostname}${file}`;
  }

  return '';
};

const BranchMap = () => {
  const { t } = useTranslation('item');
  const dispatch = useDispatch();
  const item = useSelector(getItem);
  const name = useSelector(getRetailerName);
  const location = useSelector<
    RootState,
    { lat: number; lng: number } | { lat: number; lon: number; lng?: undefined } | null
  >((s) => getRetailerLocaiton(s, item));
  const track = bindActionCreators(trackSoftConversionEvent, dispatch);

  const [showMap, setShowMap] = useState(false);
  if (!location || !name) return null;

  const { lat, lng } = location;

  if (showMap) {
    return (
      <a
        href={`//maps.google.com/maps?q=${lat},${lng}`}
        title={t('Show on Google Maps', { ns: 'item' })}
        target="_blank"
        rel="nofollow noopener noreferrer"
      >
        <img
          aria-label="map"
          src={`https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=10&size=610x286&maptype=roadmap&markers=icon:${encodeURIComponent(
            getLocalFile('/images/map/marker.png'),
          )}%7C${lat},${lng}&key=${settings.get('GoogleApiKey')}`}
          className="l-block l-full"
        />
      </a>
    );
  }

  const displayMap = () => {
    track(item, softConversionEvents.SOFT_CONVERSIONS_ITEM_DEALER_MAP_CLICK);
    setShowMap(true);
  };

  return (
    <div data-am-mapbutton="">
      <button
        type="button"
        className="map-button"
        title={t('Show map', { ns: 'item' })}
        onClick={displayMap}
        style={{
          backgroundImage: `url(${urls.cdn('/images/placeholders/placeholder_staticmap.jpg')})`,
        }}
      >
        <div className="map-button-text">
          <i className="icon-map-pin m-r-half" />
          {t('Show map', { ns: 'item' })}
        </div>
      </button>
    </div>
  );
};

export default BranchMap;
